export default __webpack_public_path__ + "static/media/l3-p6.ae9310b8.svg";